/* مزامنة محرر شوبيفاي */
(function(){
 if(!(window.Shopify&&window.Shopify.designMode))return;
 var t0=Date.now(),busy=0;
 function refresh(){ if(Date.now()-t0<2500)return; if(busy)return; busy=1; setTimeout(function(){location.reload()},200); }
 document.addEventListener('shopify:section:load',refresh);
 document.addEventListener('shopify:section:unload',refresh);
 document.addEventListener('shopify:section:select',function(e){
  if(window.ZKPAGE)return;
  var id=(e.target&&e.target.id)||'';
  var map=[['zk-bundle','bundle'],['zk-luck','luck'],['zk-detox','detox'],['zk-med','meditations'],['zk-rituals','rituals']];
  for(var i=0;i<map.length;i++){ if(id.indexOf(map[i][0])>-1){ try{go(map[i][1])}catch(err){} return; } }
 });
})();
